import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

/**
 * service to create getter setter for logged in user data
 */
export class UserConstantsService {

  private token: string;
  textChanged = false;
  textContentData: Array<any>;
  pageContentData: Array<any>;
  activateRoute = true;
  activatePageId: number;
  allContentData: Array<any>;
  containerBlock: string;
  sortBy = 1;

  /**
   * @description saves logged in users data in localstorage
   * @param userData - UserData
   */
  setUserLoggedInData(userData: string): void {
    localStorage.setItem('loggedInData', userData);
  }

  /**
   * @description gets logged in users data from localstorage
   * @returns  - Logged in data
   */
  getUserLoggedInData() {
    return JSON.parse(localStorage.getItem('loggedInData'));
  }


  /**
   * @description sets true if text of ckinline div is changed else false
   * @param textChanged - True if text is changed else false
   */
  setTextChanged(textChanged: boolean): void {
    this.textChanged = textChanged;
  }

  /**
   * @description gets true if text of ckinline div is changed else false
   * @returns - True if text is changed else false
   */
  getTextChanged(): boolean {
    return this.textChanged as boolean;
  }

  /**
   * @description saves textcontent data in an array
   * @param textContentData - Text Content data
   */
  setContentData(textContentData: Array<any>): void {
    this.textContentData = textContentData;
  }

  /**
   * @description returns Text Content data in an array
   * @returns - if available textContentData Array else null array
   */
  getContentData(): Array<any> {
    return this.textContentData ? this.textContentData : [];
  }

  /**
   * @description saves textcontent data in an array
   * @param pageContentData - Page Content Data
   */
  setPageContentData(pageContentData: Array<any>): void {
    this.pageContentData = pageContentData;
  }

  /**
   * @description returns Page Content data in an array
   * @returns - If available textContentData Array else null array
   */
  getPageContentData(): Array<any> {
    return this.pageContentData ? this.pageContentData : [];
  }

  /**
   * @description saves true if to activate first route else false
   * @param activateRoute - To activate first route or not
   */
  setActivateFirstRoute(activateRoute) {
    this.activateRoute = activateRoute;
  }

  /**
   * @description True if to activate first route else false
   * @returns returns true if to activate first route else false
   */
  getActivateFirstRoute() {
    return this.activateRoute;
  }

  setActivateWhichPage(activatePageId) {
    this.activatePageId = activatePageId;
  }

  getActivateWhichPage() {
    return this.activatePageId;
  }

  setAllContentData(allContentData: Array<any>, containerBlock: string) {
    this.allContentData = allContentData;
    this.containerBlock = containerBlock;
  }

  getAllContentData(): object {
    return ({
      allContentData : this.allContentData ? this.allContentData : [],
      containerBlock : this.containerBlock ? this.containerBlock : ''
    });
  }
  getSortBy() {
    return this.sortBy;
  }
  setSortBy(sortBy) {
    this.sortBy = sortBy;
  }
}
